var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "footer-follow", attrs: { id: "newsletter" } },
    [
      _c("div", { staticClass: "footer-follow__title" }, [
        _vm._v("\n    " + _vm._s(_vm.$t("footer_2")) + "\n  ")
      ]),
      _c("div", { staticClass: "footer-follow__subtitle" }, [
        _vm._v("\n    " + _vm._s(_vm.$t("footer_3")) + "\n  ")
      ]),
      _c(
        "input-ripple-view",
        {
          attrs: {
            type: "email",
            "marketing-concent": _vm.marketingConcent,
            "has-missing-concent": _vm.hasMissingConcent,
            placeholder: "input_1"
          },
          on: {
            "click-submit": _vm.subscribe,
            updateMarketingConcent: _vm.setMarketingConcent
          },
          model: {
            value: _vm.email,
            callback: function($$v) {
              _vm.email = $$v
            },
            expression: "email"
          }
        },
        [
          _c(
            "template",
            { slot: "icon" },
            [
              !_vm.loading
                ? _c("i", { staticClass: "icon-pointer" })
                : _vm._e(),
              _vm.loading ? _c("icon-loading-view") : _vm._e()
            ],
            1
          )
        ],
        2
      ),
      _c(
        "message-view",
        { attrs: { show: _vm.success && _vm.show } },
        [
          _c("template", { slot: "title" }, [
            _vm._v("\n      " + _vm._s(_vm.$t("message_1")) + "\n    ")
          ]),
          _c("template", { slot: "message" }, [
            _vm._v("\n      " + _vm._s(_vm.$t("message_2")) + "\n    ")
          ]),
          _c(
            "template",
            { slot: "action" },
            [
              _c(
                "button-view",
                {
                  attrs: { type: "submit", variant: "center special" },
                  nativeOn: {
                    click: function($event) {
                      _vm.show = false
                    }
                  }
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("message_6")) + "\n      "
                  )
                ]
              )
            ],
            1
          )
        ],
        2
      ),
      _c(
        "message-view",
        {
          attrs: { "has-close": true, show: !_vm.success && _vm.show },
          on: {
            "close-message": function($event) {
              _vm.show = false
            }
          }
        },
        [
          _c("template", { slot: "title" }, [
            _vm._v("\n      " + _vm._s(_vm.$t("message_5")) + "\n    ")
          ]),
          _c(
            "template",
            { slot: "field" },
            [
              _c(
                "input-view",
                {
                  attrs: {
                    type: "email",
                    variant: "error",
                    placeholder: "input_1"
                  },
                  on: { "click-submit": _vm.subscribe },
                  model: {
                    value: _vm.email,
                    callback: function($$v) {
                      _vm.email = $$v
                    },
                    expression: "email"
                  }
                },
                [
                  _c(
                    "template",
                    { slot: "icon" },
                    [
                      !_vm.loading
                        ? _c("i", { staticClass: "icon-pointer" })
                        : _vm._e(),
                      _vm.loading ? _c("icon-loading-view") : _vm._e()
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          ),
          _c(
            "template",
            { slot: "action" },
            [
              _c(
                "button-view",
                {
                  attrs: { type: "submit", variant: "center special" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.subscribe.apply(null, arguments)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("message_7")) + "\n      "
                  )
                ]
              )
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-398134ba", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-398134ba","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/footer-follow-view.vue
// module id = 245
// module chunks = 40 46 57 65